import { createContext } from 'react';

interface Context {
    requestClose?: () => void;
}

export const ModalContext = createContext<Context>({});
